<template>
  <section class="p-text">
    <div class="p-container">
      <h2 class="p-text__heading">Privacy Policy</h2>
      <div class="p-container__inner">
        <div class="p-text__container">
          <p class="p-text__lead">We the Setouchi Brand Corporation Inc. (hereafter, Setouchi Brand Corporation) believe it is our obligation to protect customer information privacy, security and settings, and copyrights.</p>

          <section class="p-text__section">
            <h3 class="p-text__subheading">Personal Information Policy</h3>
            <p class="p-text__paragraph">Setouchi Brand Corporation Inc. (hereafter, Setouchi Brand Corporation) is an organisation that aims to establish the Setouchi brand through strategic engagement in various ventures, revitalize the local economy through promotion of tourism-related industries by expanding the interaction of the local population, and realize an affluent regional community, so that people both globally and domestically recognize Setouchi as Japan’s new, leading and diverse tourist destination, and visit time and again.</p>
            <ol class="p-text__orderedList" data-type="policy">
              <li>Any information regarding an individual that Setouchi Brand Corporation has acquired through online inquires, applications, e-mail, or telephone that may be used to identify the individual (hereafter, personal information) shall be handled in the following manner.</li>
              <li>Any information that may identify an individual is defined as personal information, including name, address, telephone number, email address and such.</li>
              <li>Setouchi Brand Corporation uses acquired personal information for various purposes, including to:
                <ul class="p-text__list">
                  <li>Provide, maintain, and improve our Services;</li>
                  <li>Provide services you request and send you related information;</li>
                  <li>Send you technical notices, updates, security alerts and support, and administrative messages;</li>
                  <li>Respond to your comments, questions and requests, and provide customer service;</li>
                  <li>Communicate with you about news and information related to our Services;</li>
                  <li>Differentiate and improve our Services.</li>
                </ul>
              </li>
              <li>Setouchi Brand Corporation shall take appropriate measures for the proper use of, and to prevent the leakage, falsification, misuse, illegal access, breach of security of personal information.</li>
              <!-- <li>In any situation where Setouchi DMO requests personal information, it shall be made explicitly clear for what purpose said personal information is being requested, and only personal information within the scope of expressed purpose shall be acquired.</li> -->
              <!-- <li>Setouchi DMO shall take appropriate measures for the proper use of, and to prevent the leakage, falsification, misuse, illegal access, breach of security of personal information.</li> -->
              <li>Setouchi Brand Corporation shall not provide the acquired personal information to a third party, except in the following cases:
                <ul class="p-text__alphabetList">
                  <li>An official written request for disclosure from a party with a legal right to request disclosure. </li>
                  <li>With the explicit consent of the individual concerned.</li>
                </ul>
              </li>
              <li>If you have any questions about this Privacy Policy, please contact Setouchi Brand Corporation  at: <a href="mailto:info@ml.setouchi-bc.co.jp" class="c-link">info@ml.setouchi-bc.co.jp</a>. In the case of a request for disclosure or correction of personal information by an individual, Setouchi Brand Corporation shall only comply after verifying the individual through specified methods.</li>
              <li>Setouchi Brand Corporation shall comply with laws, ordinances, national guidelines and regulations regarding personal information protection, and strive to adhere to future changes.<br>Setouchi Brand Corporation may change this Privacy Policy from time to time. Any changes to the Privacy Policy shall be effective by posting the revised Privacy Policy.</li>
            </ol>
          </section>

          <section class="p-text__section">
            <h3 class="p-text__subheading">Copyrights</h3>
            <p class="p-text__paragraph">All information that is posted on the Setouchi Cominca Stays website (text, photographs, images, etc.) are protected by the Copyrights Law. Any unauthorized copying, reproduction, and sales are strictly forbidden except in cases stated by the Copyrights Law.</p>
          </section>

          <section class="p-text__section">
            <h3 class="p-text__subheading">Links</h3>
            <p class="p-text__paragraph">Other sites are free to publish links to Setouchi Cominca Stays website. However, please be sure to follow the rules below.</p>
            <ul class="p-text__list">
              <li>Use the Top Page address when posting links (<a href="https://cominca-stays.com" target="_blank" class="c-link">https://cominca-stays.com</a>).</li>
              <li>Explicitly specify that the link goes to the Setouchi Cominca stays Official Website.</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapMutations } from 'vuex'

  export default {
    name: 'page-privacypolicy',
    components: {
    },
    data () {
      return {
      }
    },
    beforeRouteLeave(to, from, next) {
      this.showLoader()

      next()
    },
    created() {
    },
    mounted() {
      this.$nextTick(() => {
        this.hideLoader()
      })
    },
    methods: {
      ...mapMutations({
        'showLoader': 'loader/SHOW',
        'hideLoader': 'loader/HIDE',
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/privacy_policy.vue